import { ValueOf } from './util';

export const EActionType = {
  COUNTER_CHARGE: '店頭チャージ',
  BANK_ACCOUNT_CHARGE: '銀行口座チャージ',
  CREDIT_CARD_CHARGE: 'クレジットカードチャージ',
  PREPAID_SETTLEMENT: 'プリペイド決済',
  DIRECT_BANK_SETTLEMENT: '銀行口座ダイレクト決済',
} as const;

export type ActionTypeKey = keyof typeof EActionType;
export type ActionTypeValue = ValueOf<typeof EActionType>;

export const actionTypeKeys = Object.keys(EActionType) as (ActionTypeKey[]);

/** v-select用items */
export const actionTypeItems = actionTypeKeys
  .map((key) => ({
    title: EActionType[key],
    value: key,
  }));
